import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";

export default function Login() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [validationErrors, setValidationErrors] = useState({});

  const validateForm = () => {
    const errors = {};

    // Name validation
    if (!formData.name.trim()) {
      errors.name = "Name is required";
    } else if (formData.name.trim().length < 2) {
      errors.name = "Name must be at least 2 characters";
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email.trim()) {
      errors.email = "Email is required";
    } else if (!emailRegex.test(formData.email.trim())) {
      errors.email = "Please enter a valid email address";
    }

    // Message validation (optional but if provided, must be min 5 chars)
    if (formData.message.trim() && formData.message.trim().length < 5) {
      errors.message = "Message must be at least 5 characters (or leave empty)";
    }

    return errors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    // Clear validation error for this field when user starts typing
    if (validationErrors[name]) {
      setValidationErrors({ ...validationErrors, [name]: "" });
    }
  };

  const goToStart = (userData) => {
    localStorage.setItem("user", JSON.stringify(userData));
    localStorage.setItem("isLoggedIn", "true");
    navigate("/start");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    
    // Validate form before submitting
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/users/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        const data = await res.json();
        goToStart(data.user || formData);
      } else {
        const data = await res.json();
        setError(data.message || "Something went wrong. Please try again.");
      }
    } catch {
      /* Backend unreachable — still let user proceed, save locally */
      goToStart(formData);
    } finally {
      setLoading(false);
    }
  };

  const handleSkip = () => {
    localStorage.setItem("isLoggedIn", "true");
    navigate("/start");
  };

  return (
    <div className="login-page">
      {/* Left - Form */}
      <div className="login-form-side">
        <div className="login-form-container">
          <h1>LOGIN/SIGN UP</h1>
          <p className="login-subtitle">I would love to have you on our website!</p>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-field">
              <label>HOW SHOULD WE CALL YOU?</label>
              <input type="text" name="name" placeholder="Your name"
                value={formData.name} onChange={handleChange} />
              {validationErrors.name && <p className="field-error">{validationErrors.name}</p>}
            </div>
            <div className="form-field">
              <label>YOUR EMAIL</label>
              <input type="email" name="email" placeholder="your_name@google.com"
                value={formData.email} onChange={handleChange} />
              {validationErrors.email && <p className="field-error">{validationErrors.email}</p>}
            </div>
            <div className="form-field">
              <label>ANY MESSAGES FOR US</label>
              <textarea name="message" placeholder="Hi, I write to you about..." rows="5"
                value={formData.message} onChange={handleChange} />
              {validationErrors.message && <p className="field-error">{validationErrors.message}</p>}
            </div>

            {error && <p className="login-error">{error}</p>}

            <button type="submit" className="btn-login" disabled={loading}>
              {loading ? "Entering..." : "I'M IN (ENTER)"}
            </button>
          </form>

          <button onClick={handleSkip} className="btn-skip">SKIP FOR NOW</button>
        </div>
      </div>

      {/* Right - Logo (clean, no animation) */}
      <div className="login-logo-side">
        <img src="/logo-icon.png" alt="iG" className="login-logo-large" />
      </div>
    </div>
  );
}
